import { Controller } from "@hotwired/stimulus"
import { createEditor } from "../tiptap/editor"

export default class extends Controller {
  static targets = ["input", "editor"]
  static values = {
    content: { type: String, default: "" },
    placeholder: { type: String, default: "Write something..." },
    mentionsUrl: { type: String, default: "" },
    autofocus: { type: Boolean, default: false },
  }

  connect() {
    let content = null
    if (this.contentValue) {
      try {
        content = JSON.parse(this.contentValue)
      } catch {
        content = null
      }
    }

    this.tiptapEditor = createEditor({
      element: this.editorTarget,
      content,
      placeholder: this.placeholderValue,
      mentionsUrl: this.mentionsUrlValue || null,
      onUpdate: (json) => {
        this.inputTarget.value = JSON.stringify(json)
      },
    })

    // Sync initial content to hidden input
    if (content) {
      this.inputTarget.value = JSON.stringify(content)
    }

    if (this.autofocusValue) {
      this.tiptapEditor.commands.focus()
    }

    this._handleReply = this._handleReply.bind(this)
    document.addEventListener("comment:reply", this._handleReply)
  }

  focus() {
    this.editorTarget.querySelector(".ProseMirror")?.focus()
  }

  _handleReply(event) {
    // Only handle if this editor is inside #comment-form (the main post reply box)
    const commentForm = document.getElementById("comment-form")
    if (!commentForm || !commentForm.contains(this.element)) return

    this._insertBlockquote(event.detail.bodyJson)

    // Record which comment is being replied to
    const hiddenField = commentForm.querySelector('input[name="comment[replied_to_comment_id]"]')
    if (hiddenField && event.detail.commentId) {
      hiddenField.value = event.detail.commentId
    }

    this.element.scrollIntoView({ behavior: "smooth", block: "center" })
  }

  _insertBlockquote(bodyJson) {
    if (!this.tiptapEditor) return

    const quoteContent = bodyJson?.content || []

    // insertContentAt(0, ...) PREPENDS without replacing existing content
    this.tiptapEditor
      .chain()
      .focus()
      .insertContentAt(0, [
        { type: "blockquote", content: quoteContent },
        { type: "paragraph" },
      ])
      .run()
  }

  disconnect() {
    if (this.tiptapEditor) {
      this.tiptapEditor.destroy()
      this.tiptapEditor = null
    }
    document.removeEventListener("comment:reply", this._handleReply)
  }
}
